import services from './../../services/service'; // Service Class
import HomeLanding from './../Home/index.vue'; // Main Footer
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 
//
import AccountResources from './../Account/Resources/commonfunctions.js';

let service = new services();
export default {
    name: 'Home',
    mixins: [AccountResources],
    data () {
        return {
            user:{},
            categories:{},
            market:{},
            market_groups:{},
            market_trending:{},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view:{},
            show_login:false,
            show_landing:true,
            header_data:{},
            has_shops:true,
            //
            set_view_box:'',
            businesses:{},
            set_cateogries:{},
        }
    },
  
    components: {
        'component-landing': HomeLanding,
        'component-header': MainHeader,
        'component-sticky-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                   // self.show_login=true;
                    // self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        setMarketRemote(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data; 
                    this.businesses = this.market.business_markets;
                    this.loading = false;
                //    this.getProducts();
                }
            }).catch((err) => {
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        setMarketActivities(){
            service.getMarketActivityProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_trending = response.body.data; 
                    this.products = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMarketGroups(){
            service.getMarketGroupsProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_groups = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMenuComponent(view,view_type,attr1,attr2){  
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
        },

        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
            })
        },

        getSellpoint(){
            this.loading = true;
            service.getBusinessByUserName(this, 'Kedi1674857669').then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    this.setBusinessDetails();
                    this.getSellpointProducts();
                }
            }).catch((err) => {})
        },

        setBusinessDetails(){
            service.getBusinessByUserName(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    //setts
                    //----------delivery-locations
                    this.business_delivery_locations = this.sellpoint.business_delivery_options;
                    //----------./delivery-locations

                    //----------bank-details
                    this.business_bank_details = this.sellpoint.business_bank_details;
                    //----------./bank-details
                } 
            }).catch((err) => {})
        },
    
        getSellpointProducts(){
            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    for(let product of this.products){
                        for(let item of product.product_items){
                            item.product_name = product.product_name;
                            item.product_item_order_quantity = 1; //set as default // for oreder prep
                        }
                        this.set_order_addons.push(product)
                    }

                    //some setts
                    this.set_order_data.order_items = []; //ini
                    //

                    this.loading = false;
                }
            }).catch((err) => {})
        },

        setFeaturedCategories(){
            //props
            this.set_categories = [
                {category_name:'Swallow',
                category_color:'#ff0979'},
                {category_name:'Drinks',
                category_color:'#ff9979'},
                {category_name:'Swallow',category_color:'#ff3189'},
                {category_name:'Drinks',
                category_color:'#ff1939'},
            ];
        },
        //procs
        
        setViewBox(view){
            if(this.set_view_box == ''){
                this.setMenuTabInnerView('');
                this.toggleSingleComponent('shareBox');
            }else{
                this.setMenuTabInnerView('setOptions');
                //
                this.set_view_box = view;
            }
            
        },
        //../procs
    },
    created: function(){
        if(localStorage.getItem('appOn')){
            this.show_landing = false;
        }else{
            //
            localStorage.setItem('appOn',1); //check best unset later //use time count
        }
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setFeaturedCategories();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Timeline/script.js